'use strict'

var Backbone = require('backbone')
var Marionette = require('marionette')
var App = require('app')

var List = require('./list')
var EditNew = require('./edit_new')

var ClientUsersList = function () {
  //
  var API = {
    listUsers: function (options) {
      var usersList = new List(options)
      usersList.listUsers()
    },
    editNewUser: function (options) {
      new EditNew(options)
    }
  }

  App.globalChannel.on('client-users:list', function (options) {
    API.listUsers(options)
  })

  App.globalChannel.on('client-users:new', function (options) {
    API.editNewUser(options)
  })

  App.globalChannel.on('client-users:edit', function (options) {
    API.editNewUser(options)
  })
}

module.exports = ClientUsersList



// WEBPACK FOOTER //
// ./js/modules/client-users/index.js